Object.defineProperty(exports, "__esModule", {
  value: true
});
var AIRBNB_PRODUCTS = exports.AIRBNB_PRODUCTS = 'Airbnb products';
var AIRMOJI = exports.AIRMOJI = 'centered airmoji';
var ALERTS = exports.ALERTS = 'alerts';
var AMENITIES = exports.AMENITIES = 'amenities';
var BADGES = exports.BADGES = 'badges';
var BED_TYPES = exports.BED_TYPES = 'bed types';
var BUSINESS_TRAVEL = exports.BUSINESS_TRAVEL = 'business travel';
var CHECKMARKS = exports.CHECKMARKS = 'checkmarks';
var COMMUNICATION = exports.COMMUNICATION = 'communication';
var CURRENCIES = exports.CURRENCIES = 'currencies';
var DATE_TIME = exports.DATE_TIME = 'date and time';
var DEVICES = exports.DEVICES = 'devices';
var DIRECTIONS = exports.DIRECTIONS = 'directions';
var FLAGS = exports.FLAGS = 'flags';
var GENERAL_WEB_PRODUCTS = exports.GENERAL_WEB_PRODUCTS = 'general web products';
var HEARTS = exports.HEARTS = 'hearts';
var IDENTITY = exports.IDENTITY = 'identity';
var IMAGE_MANIPULATION = exports.IMAGE_MANIPULATION = 'image manipulation';
var INDICATOR = exports.INDICATOR = 'indicator';
var LOCATION = exports.LOCATION = 'location';
var MARQUEE_NAV = exports.MARQUEE_NAV = 'marquee nav';
var MEDIA = exports.MEDIA = 'media';
var MISCELLANEOUS = exports.MISCELLANEOUS = 'miscellaneous';
var P3 = exports.P3 = 'p3';
var PAYMENTS = exports.PAYMENTS = 'payments';
var PEOPLE = exports.PEOPLE = 'people';
var PROPERTY_TYPES = exports.PROPERTY_TYPES = 'property types';
var SAFETY = exports.SAFETY = 'safety';
var SEARCH = exports.SEARCH = 'search';
var SIDE_DRAWER = exports.SIDE_DRAWER = 'side drawer';
var SOCIAL = exports.SOCIAL = 'social';
var STARS = exports.STARS = 'stars';
var TRANSPORT = exports.TRANSPORT = 'transport';
var URGENCY_COMMITMENT = exports.URGENCY_COMMITMENT = 'urgency and commitment';
var WEATHER = exports.WEATHER = 'weather';


//////////////////
// WEBPACK FOOTER
// ./~/airbnb-dls-web/build/utils/iconCategories.js
// module id = 17
// module chunks = 168707334958949